import Model, { attr, belongsTo } from '@ember-data/model';
import { apiAction } from '@mainmatter/ember-api-actions';
import { service } from '@ember/service';

export default class ProtectInvite extends Model {
  @service store;

  @belongsTo('location', { async: true, inverse: null }) location;
  @belongsTo('flow', { async: true, inverse: null }) flow;
  @belongsTo('entry', { async: true, inverse: null }) entry;
  @attr('string') email;
  @attr('string') fullName;
  @attr('date') expectedArrivalTime;
  @attr('string') preregistrationLink;
  @attr('string') approvalStatus;
  @attr('boolean') isPresigned;
  @attr('date') guestUpdatedAt;

  async signIn() {
    const payload = {
      data: {
        type: 'entries',
        attributes: {
          'sign-in-method': 'Employee web registration',
        },
        relationships: {
          invite: {
            data: {
              type: 'invites',
              id: this.id,
            },
          },
        },
      },
    };
    const response = await apiAction(this, {
      data: payload,
      method: 'POST',
      path: 'from_invite',
      requestType: 'signIn',
    });

    const serializer = this.store.serializerFor('entry');
    const id = response.data.id;
    const normalized = serializer.normalizeSingleResponse(this.store, 'entry', response, id, 'findRecord');
    this.store.push(normalized);
    return id;
  }
}
